import novaClient from "./client";
import type { NovaPpc, NovaListResponse } from "./types";

export interface GetPpcParams {
  participantId?: string;
  status?: string;
  location?: string;
  programType?: string;
  isReferral?: boolean;
  limit?: number;
}

export async function getPpcList(
  params: GetPpcParams = {},
): Promise<NovaListResponse<NovaPpc>> {
  const res = await novaClient.get<NovaListResponse<NovaPpc>>("/ppc/list", {
    params,
  });
  return res.data;
}

export async function getPpcById(ppcId: string): Promise<NovaPpc> {
  const res = await novaClient.get<NovaPpc>(`/ppc/${ppcId}`);
  return res.data;
}

export async function assignProgram(
  ppcId: string,
  programId: string,
): Promise<void> {
  await novaClient.post(`/ppc/${ppcId}/assign-program/${programId}`);
}

export async function advancePhase(ppcId: string): Promise<void> {
  await novaClient.post(`/ppc/${ppcId}/advance-phase`);
}

export interface UpdatePpcPayload {
  eligibilityNote?: string;
}

export async function updatePpc(
  ppcId: string,
  payload: UpdatePpcPayload,
): Promise<NovaPpc> {
  const res = await novaClient.patch<NovaPpc>(`/ppc/${ppcId}`, payload);
  return res.data;
}

export interface UpdateEligibilitySuitabilityPayload {
  eligibilityHearingDate?: string | null;
  eligibilityOutcome?: number | null;
  eligibilityNote?: string;
  suitabilityHearingDate?: string | null;
  suitabilityOutcome?: number | null;
  daWaiver?: number | null;
  closedDate?: string | null;
  closedReason?: number | null;
  closedDetails?: number | null;
  evaluationHidden?: boolean;
  /** Super users only: explicit Lock/Unlock override. */
  evaluationLocked?: boolean;
  /** First successful submit: backend sets submitted + hidden (lock). */
  submitEvaluation?: boolean;
}

export async function updateEligibilitySuitability(
  ppcId: string,
  payload: UpdateEligibilitySuitabilityPayload,
): Promise<void> {
  await novaClient.post(`/ppc/${ppcId}/eligibilitysuitability`, payload);
}

export async function setBenefitsNeededFlag(
  ppcId: string,
  active: boolean,
): Promise<void> {
  await novaClient.put(`/ppc/${ppcId}/flags/benefits-needed`, { active });
}
